import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from "recharts";
import { Card } from "react-bootstrap";


const GraficoOrdiniFornitori = () => {
  const [dataGrafico, setDataGrafico] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((json) => {
        // 1. Estraiamo e appiattiamo gli ORDINI_URGENTI
        const ordiniRaw = json?.ORDINI_URGENTI?.flat() || [];

        // 2. Filtriamo solo Tipo Riga "T" e raggruppiamo per fornitore
        const raggruppati = ordiniRaw
          .filter(item => item["Tipo Riga"] === "T")
          .reduce((acc, curr) => {
            const nome = curr["Ragione sociale"] || "Sconosciuto";
            const importo = parseFloat(curr["Importo"]) || 0;

            if (!acc[nome]) {
              acc[nome] = 0;
            }
            acc[nome] += importo;
            return acc;
          }, {});

        // 3. Trasformiamo l'oggetto in un array compatibile con Recharts
        const formattedData = Object.keys(raggruppati).map((key) => ({
          name: key,
          totaleImporto: parseFloat(raggruppati[key].toFixed(2)),
        }));

        // Ordiniamo dal più grande al più piccolo
        formattedData.sort((a, b) => b.totaleImporto - a.totaleImporto);

        setDataGrafico(formattedData);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch grafico:", err);
        setLoading(false);
      });
  }, []);

  const formatXAxis = (tickItem) => {
    if (tickItem.length > 10) {
      return `${tickItem.substring(0, 10)}...`;
    }
    return tickItem;
  };

  if (loading) return <div className="text-center p-5">Caricamento grafico...</div>;

  return (
    <Card className="ombra ordini-ora card-home hover-effect">
<div className="mt-1 mx-auto">
      <p className="text-title p-1 rounded">
        FORNITORI CON ORDINI URGENTI - IMPORTO TOTALE
      </p>
    </div>      
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={dataGrafico}
margin={{
          top: 0,
          right: 20,
          left: 20,
          bottom: 30,
        }}        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis 
            dataKey="name" 
            tickFormatter={formatXAxis} // <--- QUI TRONCHIAMO IL TESTO
            interval={0} 
            angle={-30} 
            textAnchor="end"
            style={{ fontSize: '10px', fill: '#666' }}
          />
          <YAxis tickFormatter={(value) => `€${value}`} style={{ fontSize: '0.8rem' }} />
          <Tooltip 
            formatter={(value) => [`€ ${value.toLocaleString()}`, 'Importo Totale']}
            contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
          />
         <Bar 
            dataKey="totaleImporto" 
            fill="#b81f25" // Il tuo colore rosso
            style={{ filter: "url(#blurFilter)" }} 
          />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default GraficoOrdiniFornitori;